import { z } from 'zod';
/**
 * Контракт ответа эндпоинтов `/api/healthz` и `/api/readyz`.
 *
 * Схема зафиксирована в `@lens/shared`, чтобы бэкенд и фронтенд
 * не расходились по форме ответа — это единственный источник правды.
 */
export const HealthResponseSchema = z.object({
    ok: z.boolean(),
});
